import Modal from 'react-modal';
import { useState, useEffect, useRef } from 'react';
import { makeSearch, changeDisable, setMaskGeneric, viewItem, hoursNow, dateToday, setMaskDecimal, parseToFloat, setMaskHour, getParameter,  getPermission, customFullModal, customShortModal, showMessageError, getUsers, showIconDivergence, customHalfModal, convertStringValueToBoolean, custom } from '../../../classes/functions';
import '../../../components/Modal/modal.css';
import './receipt.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { FaPen, FaArrowAltCircleLeft, FaCog, FaPlus, FaTrash, FaCheck, FaClipboard, FaSearch, FaMinus, FaPrint, FaUser } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import ModalChoice from '../../../components/Modal/ModalChoice';
import "../../../components/Modal/ModalConfirmation/index.js";
import Select from "react-select";
import { ImCross } from 'react-icons/im';
import axios from 'axios';
import download from 'downloadjs';
import baseUrl from '../../../baseUrl.js';
import InputDate from '../../../components/Inputs/Date/index.js';
import ModalAuxiliaresData from '../../../components/Modal/ModalAuxiliaresData/index.js';

export default function ReceiptDocuments() {
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [enableSave, setEnableSave] = useState(false);
  const [disabled_feature, setDisabledFeature] = useState('inline');
  const [dataTable, setDataTable] = useState('tableScrollBig');
  const [disabled_enderecamento, setDisabledEnderecamento] = useState(true);
  const [modalReleasedRef, setModalReleasedRef] = useState(false);
  const [sumConference, setSumConference] = useState('');
  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [showModalAuxiliariesData, setShowModalAuxiliariesData] = useState(false);
  const [headerAuxiliaresDatas, setHeaderAuxiliaresDatas] = useState({
    processo: "",
    servico: "",
    lote: "",
    container: "",
    consolidado: ""
  });
  const [currentItem, setCurrentItem] = useState(0);
  const [generationTags, setGenerationTags] = useState({
    label_product: '',
    id_product: '',
    quantity: 0
  });
  const [showModals, setShowModals] = useState({
    modalConfirmClearConference: false,
    modalConfirmPrintTags: false,
    modalEditWarehouseReceipt: false,
    conferenceOpen: false,
    modalTagsReceipt: false,
    conferenceOpenWithoutTag: false,
    enderecamentoOpen: false,
    confirmExit: false,
    confirmAddressing: false,
    featuresOpen: false,
    confirmFinishPalete: false,
    releasedRef: false,
    confirmStatus: false,
    addressingOpen: false,
    removeConference: false,
    changeAddresser: false,
    addressers: false
  });
  const [infos, setInfos] = useState({
    data_emissao: "",
    data_entrada: "",
    data_conferencia: "",
    data_enderecamento: "",
  });
  const [request_pallet, setRequestPallet] = useState(false);
  const [modalConfirmStatus, setModalConfirmStatus] = useState(false);
  const [statusFlow] = useState(getParameter('FLUXO_STATUS'));
  const [conferenceStatus] = useState(getParameter('STATUS_CONFERENCIA').split(','));
  const [parameterTagCompanie] = useState(getParameter('SOLICITA_ETIQUETA_PALETE'));
  const [parameterTagClient, setParameterTagClient] = useState('N');
  const [blockWarehouseReceipt] = useState(getParameter('BLOQUEIA_ARMAZEM_RECEBIMENTO'));
  const [modalRemoveConference, setModalRemoveConference] = useState(false);
  const [modalReleaseConference, setModalReleaseConference] = useState(false);
  const focusModalRef = useRef(null);
  const [releasedRefBox, setReleasedRefBox] = useState(false);
  const [totalQtde, setTotalQtde] = useState('');
  const [totalQtdeConferida, setTotalQtdeConferida] = useState('');
  const [edit_warehouse_receipt, setEditWarehouseReceipt] = useState('');
  const [status, setStatus] = useState('');
  const [id_documento_entrada, setDocumentoEntrada] = useState('');
  const [numero_documento, setNumeroDocumento] = useState('');
  const [serie_documento, setSerieDocumento] = useState('');
  const [label_status, setLabelStatus] = useState('');
  const [nome_cliente, setNomeCliente] = useState('');
  const [search_addessing, setSearchAddessing] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [hora_entrada, setHoraEntrada] = useState('');
  const [warehouse_receipt, setWarehouseReceipt] = useState('');
  const [label_warehouse_receipt, setLabelWarehouseReceipt] = useState('');
  const [observation, setObservation] = useState('');
  const [transshipment, setTransshipment] = useState('')
  const [origin, setOrigin] = useState('');
  const [originId, setOriginId] = useState('');
  const [itens, setItens] = useState([]);
  const [conferencia, setConferencia] = useState([]);
  const [enderecamento, setEnderecamento] = useState([]);
  const [itens_removidos, setItensRemovidos] = useState([]);
  const [conferencia_removidos, setConferenciaRemovidos] = useState([]);
  const [enderecamento_removidos, setEnderecamentoRemovidos] = useState([]);
  const [item_enderecamento_removidos, setItemEnderecamentoRemovidos] = useState([]);
  const [listTagsToPrint, setListTagsToPrint] = useState([]);
  const [listTagsReceipt, setListTagsReceipt] = useState([]);
  const [listTagsReceiptByProduct, setListTagsReceiptByProduct] = useState([]);
  const [enderecador, setEnderecador] = useState({});
  const [itemViewModalAddressing, setItemViewModalAddressing] = useState({});
  const [ident_conferencia, setIdentConferencia] = useState('new');
  const [produto_conferencia, setProdutoConferencia] = useState('');
  const [um_conferencia, setUmConferencia] = useState('');
  const [tipo_produto_conferencia, setTipoProdutoConferencia] = useState('');
  const [status_conferencia, setStatusConferencia] = useState('');
  const [qtde_conferida_conferencia, setQtdeConferidaConferencia] = useState('');
  const [lote_conferencia, setLoteConferencia] = useState('');
  const [serie_conferencia, setSerieConferencia] = useState('');
  const [mac_conferencia, setMacConferencia] = useState('');
  const [allow_change_lote_conferencia, setAllowChangeLoteConferencia] = useState('');
  const [allow_new_lote_conferencia, setAllowNewLoteConferencia] = useState('');
  const [batchs_conferencia, setBatchsConferencia] = useState([]);
  const [controls_batch_conferencia, setControlsBatchConferencia] = useState('');
  const [controls_serie_conferencia, setControlsSerieConferencia] = useState('');
  const [controls_mac_conferencia, setControlsMacConferencia] = useState('');
  const [numero_serie_conferencia, setNumeroSerieConferencia] = useState('');
  const [numero_mac_conferencia, setNumeroMacConferencia] = useState('');
  const [etiqueta_palete_conferencia, setEtiquetaPaleteConferencia] = useState('');
  const [hora_conferencia, setHoraConferencia] = useState('');
  const [referencia_caixa_conferencia, setReferenciaCaixaConferencia] = useState('');
  const [nome_usuario_conferencia, setNomeUsuarioConferencia] = useState('');
  const [indexRemoveConference, setIndexRemoveConference] = useState('');
  const [itemRemoveConference, setItemRemoveConference] = useState({});
  const [itemToRemove, setItemToRemove] = useState({});
  const [ident_enderecamento, setIdentEnderecamento] = useState('new');
  const [endereco_enderecamento, setEnderecoEnderecamento] = useState('');
  const [warehouse_enderecamento, setWarehouseEnderecamento] = useState('');
  const [warehouse_mandatory, setWarehouseMandatory] = useState('');
  const [etiqueta_palete_enderecamento, setEtiquetaPaleteEnderecamento] = useState('');
  const [hora_enderecamento, setHoraEnderecamento] = useState('');
  const [usuario_enderecamento, setUsuarioEnderecamento] = useState('');
  const [conferenceIdProduct, setConferenceIdProduct] = useState('');
  const [conferenceProduct, setConferenceProduct] = useState('');
  const [conferencePalete, setConferencePalete] = useState('');
  const [conferenceQtde, setConferenceQtde] = useState('');
  const [conferenceRefCaixa, setConferenceRefCaixa] = useState('');
  const [conferenceFeatures, setConferenceFeatures] = useState([]);
  const [listUnidades, setListUnidades] = useState([]);
  const [listTiposProdutos, setListTipoProdutos] = useState([]);
  const [listStatusItem, setListStatusItem] = useState([]);
  const [listEnderecos, setListEnderecos] = useState([]);
  const [listPoductsConference, setListPoductsConference] = useState([]);
  const [listWarehouse, setListWarehouses] = useState([]);
  const [listAllFeatures, setListAllFeatures] = useState([]);
  const [viewItens, setViewItens] = useState([]);
  const [searchPalete, setSearchPalete] = useState('');
  const [feature, setFeature] = useState([]);
  const [listSearchDocuments, setListSearchDocuments] = useState([]);
  const [listSearchAllConference, setListSearchAllConference] = useState([]);
  const [termSearchConference, setTermSearchConference] = useState('');
  const [listItemsToAddress, setListItemsToAddress] = useState([]);
  const [listSearchAllAdressing, setListSearchAllAdressing] = useState([]);
  const [termSearchAdressing, setTermSearchAdressing] = useState('');
  const [confirmationOperation, setConfirmationOperation] = useState();
  const [currentReceiptTable, setCurrentReceiptTable] = useState(1);
  const [rowReceiptTableWasClicked, setRowReceiptTableWasClicked] = useState([{ id: 1, clicked: true }, { id: 2, clicked: false }, { id: 3, clicked: false }]);
  const receivingAddressing = parseInt(getParameter("DEFINE_ENDERECADOR") || 1);

  useEffect(() => {
    async function loadUser() {
      if (id) {
        getOne(id, option);
      }
    }

    getData();
    loadUser();

    if (parameterTagCompanie === 'F') {
      setDataTable('');
    }
  }, []);

  function changeAddresser() {
    const data = {
      row: {
        id: id,
        associado_para: enderecador.value
      }
    };

    api
      .put("/api/receipt_documents/put", data)
      .then((response) => {
        toast.success('Endereçador atualizado com sucesso.');
      })
      .catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function save(e) {
    setCarrying(true);
    e.preventDefault();

    const data = {
      row: {
        id_documento_entrada: id_documento_entrada,
        status: status,
        observacao: observation,
      },
      itens: itens,
      conferencia: conferencia,
      enderecamento: enderecamento,
      itens_removidos: itens_removidos,
      conferencia_removidos: conferencia_removidos,
      enderecamento_removidos: enderecamento_removidos,
      item_enderecamento_removidos: item_enderecamento_removidos,
    }

    api
      .post("/api/receipt_documents/post", data)
      .then((response) => {
        toast.success('Registro inserido com sucesso.');
        history.push('/receipt_documents');
      })
      .catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function getOne(id, option) {
    api.get("/api/receipt_documents/getList?id=" + id)
      .then((response) => {
        setDocumentoEntrada(response.data.row.id_documento_entrada);
        setStatus(response.data.row.status);
        setLabelStatus(response.data.row.label_status);
        setNumeroDocumento(response.data.row.numero_documento);
        setSerieDocumento(response.data.row.serie_documento);
        setNomeCliente(response.data.row.nome_cliente);
        setParameterTagClient(response.data.row.controls_pallet);
        setCidade(response.data.row.cidade);
        setEstado(response.data.row.estado);
        setInfos((prevState) => ({...prevState, data_emissao: response.data.row.data_emissao, data_entrada: response.data.row.data_entrada}));
        setHoraEntrada(response.data.row.hora_entrada);
        setWarehouseReceipt(response.data.row.warehouse_receipt);
        setLabelWarehouseReceipt(response.data.row.label_warehouse_receipt);
        setObservation(response.data.row.observacao);
        setTransshipment(response.data.row.transbordo);
        setOrigin(response.data.row.origin);
        setOriginId(response.data.row.origin_id);
        setItens(response.data.itens);
        setConferencia(response.data.conferencia);
        setListSearchAllConference(response.data.conferencia);
        setEnderecamento(response.data.enderecamento);
        setListSearchAllAdressing(response.data.enderecamento);
        setEnderecador({ value: response?.data?.row?.enderecador?.id, label: response?.data?.row?.enderecador?.nome });
        setHeaderAuxiliaresDatas(response.data.row.dados_aux);

        let aux_qtde = 0;
        let aux_qtde_conferida = 0;

        response.data.itens.map((element) => {
          if (!element.qtde_conferida_item) {
            element.qtde_conferida_item = 0;
          }
          if (!element.quantidade_item) {
            element.quantidade_item = 0;
          }
          aux_qtde += parseFloat(element.quantidade_item);
          aux_qtde_conferida += parseFloat(element.qtde_conferida_item);
        });

        setTotalQtde(aux_qtde.toFixed(2).toString().replace('.', ','));
        setTotalQtdeConferida(aux_qtde_conferida.toFixed(2).toString().replace('.', ','));
        setCarrying(false);
      }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });

    setView(changeDisable(option));
  }

  function cancel() {
    history.push('/receipt_documents');
  }

  async function getData() {
    if (id) {
      api.get("/api/receipt_documents/getDataPage?id=" + id)
        .then((response) => {
          setListTipoProdutos(response.data.tipos_produtos);
          setListAllFeatures(response.data.caracteristicas);
          setListStatusItem(response.data.status_item);
          setListWarehouses(response.data.warehouses);
          setListUnidades(response.data.unidades);
        }).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
    }
  }

  async function setListTags(index, value) {
    let aux = [];

    listTagsReceipt.forEach((element, inx) => {
      if (inx == index) {
        element.quantity_generate = parseToFloat(value.toUpperCase());
      }
      aux.push(element)
    });

    setListTagsReceipt(() => aux);
  }

  async function setList(index, value) {
    let aux = [];

    conferenceFeatures.forEach((element, inx) => {
      if (inx == index) {
        element.valor = value.toUpperCase();
      }
      aux.push(element)
    });

    setConferenceFeatures(() => aux);
  }

  function inicializeConferencia() {
    setIdentConferencia('new');
    setProdutoConferencia('');
    setUmConferencia('');
    setTipoProdutoConferencia('');
    setQtdeConferidaConferencia('');
    setLoteConferencia('');
    setSerieConferencia('');
    setMacConferencia('');
    setAllowChangeLoteConferencia('');
    setControlsBatchConferencia('');
    setControlsSerieConferencia('');
    setControlsMacConferencia('');
    setNumeroSerieConferencia('');
    setNumeroMacConferencia('');
    setReferenciaCaixaConferencia('');
    setInfos((prevState) => ({...prevState, data_conferencia: ""}));
    setHoraConferencia('');
    setNomeUsuarioConferencia('');
  }

  function editConferencia(ident, item) {
    setIdentConferencia(ident);
    setProdutoConferencia(item.produto_conferencia);
    setUmConferencia(item.um_conferencia);
    setTipoProdutoConferencia(item.tipo_produto_conferencia);
    setQtdeConferidaConferencia(item.qtde_conferida_conferencia);
    setLoteConferencia(item.lote_conferencia);
    setNumeroSerieConferencia(item.numero_serie_conferencia);
    setNumeroMacConferencia(item.numero_mac_conferencia);
    setEtiquetaPaleteConferencia(item.etiqueta_palete_conferencia);
    setReferenciaCaixaConferencia(item.referencia_caixa_conferencia);
    setNomeUsuarioConferencia(item.nome_usuario_conferencia);
    setInfos((prevState) => ({...prevState, data_conferencia: item.data_conferencia}));
    setHoraConferencia(item.hora_conferencia);
  }

  function setClearConference(){
    itemToRemove.recebimento = id;
    api.put("/api/conferred/setClearConferenceByItem", itemToRemove)
    .then((response) => {
      toast.success('Limpeza da conferência realizada com sucesso!');
      setShowModals((prevState) => ({ ...prevState, modalConfirmClearConference: false }));
      setChanges(response);
    }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  function removeConferencia(index, item) {
    let data = {
      data: {
        id: item.ident_conferencia,
        operation: 'D'
      }
    };

    api.post("/api/conferred/editItem", data)
      .then((response) => {
        toast.success('Registro Removido!');
        getOne(id, option);
      }
      ).catch((error) => {
        showMessageError(error.response.data);
      });
  }

  function salvarConferencia() {
    setEnableSave(true);

    const data = {
      list: [{
        id: conferencia[ident_conferencia].ident_conferencia,
        id_recebimento: id,
        qtde_conferida: qtde_conferida_conferencia,
        referencia_caixa: referencia_caixa_conferencia,
        lote: lote_conferencia,
        numero_serie: numero_serie_conferencia,
        numero_mac: numero_mac_conferencia,
        id_usuario: localStorage.usuario
      }]
    };

    api.post("/api/receipt_documents/setConferenceWithoutTagEdit", data)
      .then((response) => {
        setChanges(response);
        inicializeConferencia();
      }).catch((error) => {
        showMessageError(error.response.data);
        setEnableSave(false);
      });    
  }

  function inicializeEnderecamento() {
    setIdentEnderecamento('new');
    setEnderecoEnderecamento('');
    setEtiquetaPaleteEnderecamento('');
    setInfos((prevState) => ({...prevState, data_enderecamento: ""}));
    setHoraEnderecamento('');
    setUsuarioEnderecamento('');
    setDisabledEnderecamento(true);
  }

  function showAddressItem(ident, item) {
    if ((receivingAddressing === 2 && parseInt(localStorage.getItem("usuario") === enderecador.value)) || receivingAddressing != 2) {
      api.get("/api/receipt_documents/getItemDevolutionToAddress?origin=" + originId + "&product=" + item.etiqueta_produto_enderecamento)
        .then((response) => {
          setSumConference(item.qtde_conferida_enderecamento);
          setListItemsToAddress(response.data);
          setShowModals((prevState) => ({ ...prevState, addressingOpen: true }));
        }).catch((error) => {
          showMessageError(error.response.data);
        });
    } else {
      toast.error(`O endereçador designado para este documento é o ${enderecador.label}`)
    }
  }

  function editEnderecamento(ident, item) {
    if ((receivingAddressing === 2 && parseInt(localStorage.getItem("usuario")) === enderecador.value) || receivingAddressing != 2) {
      if (item.finalizado_enderecamento === 'S') {
        setIdentEnderecamento(ident);
        setEnderecoEnderecamento(item.endereco_enderecamento);
        setWarehouseEnderecamento(item.warehouse_mandatory);
        setWarehouseMandatory(item.warehouse_mandatory);
        setEtiquetaPaleteEnderecamento(item.etiqueta_palete_enderecamento);
        setInfos((prevState) => ({...prevState, data_enderecamento: item.data_enderecamento}));
        setHoraEnderecamento(item.hora_enderecamento);
        setUsuarioEnderecamento(item.usuario_enderecamento);
        setDisabledEnderecamento(false);

        if (warehouse_receipt) {
          selectWarehouse(warehouse_receipt);
          setWarehouseEnderecamento(warehouse_receipt);
        }
        if (item.warehouse_mandatory && item.warehouse_mandatory != '') {
          api.get("/api/getAdressesAvailable?warehouse=" + item.warehouse_mandatory)
            .then((response) => {
              setListEnderecos(response.data.enderecos);
            }).catch((error) => {
              showMessageError(error.response.data);
            });
        }
      } else {
        toast.error('Finalize o palete antes de endereçar.');
      }
    } else {
      toast.error(`O endereçador designado para este documento é o ${enderecador.label}`)
    }
  }

  function viewAddressing(item) {
    setItemViewModalAddressing(item);
    showItem(item, '');
  }
  
  function showItem(item, term) {
    api.get("/api/receipt_documents/getSubItens?id=" + item.id + "&term=" + term)
      .then((response) => {
        setViewItens(response.data);
        setShowModals((prevState) => ({ enderecamentoOpen: true }));
      }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function searchAdressing(e) {
    setTermSearchAdressing(e.target.value);
    setListSearchAllAdressing(makeSearch(enderecamento, ['data_enderecamento', 'etiqueta_palete_enderecamento', 'hora_enderecamento', 'usuario_enderecamento'], e.target.value));
  }

  function setAddressReturn() {
    if (validAddressingReturn()) {
      setCarrying(true);
      let aux = [];
      listItemsToAddress.map((element) => {
        element.addresses = [];
        aux.push(element);
      });

      closeModal();
      api.post("/api/receipt_documents/setAddressingReturn", { list: aux, id_recebimento: id })
        .then((response) => {
          getOne(id, option);

          if (response.data.status && response.data.status == '006') {
            api.get("/api/return_request/setIntegratedErp?id=" + originId)
              .then((response) => {
              }).catch((error) => {
              });
          }
        }).catch((error) => {
          setCarrying(false);
          setShowModals((prevState) => ({ ...prevState, addressingOpen: true }))
          toast.error(error.response.data.message);
        });
    }
  }

  function validAddressingReturn() {
    let sum = 0;
    let valid = true;

    listItemsToAddress.map((element) => {
      sum += parseToFloat(element.quantity_address);

      if ((!element.address || element.address == '') || (!element.quantity_address || element.quantity_address == '')) {
        toast.error('Selecione o endereço e preencha a quantidade para todos os armazéns!');
        valid = false;
      }
    });

    const result = itens.find(item => item.id_produto_item === listItemsToAddress[0].id_product);

    if (sum != result.qtde_conferida_item) {
      toast.error('Quantidade enderaçada é diferente conferida para esse item!');
      valid = false;
    }

    return valid;
  }

  function setAddressItem(item, value) {
    listItemsToAddress[item].address = value;
  }

  function setQuantityItem(item, value) {
    listItemsToAddress[item].quantity_address = value;
  }

  function salvarEnderecamento() {
    setEnableSave(true);

    const data = {
      list: [{
        id_enderecamento: enderecamento[ident_enderecamento].id,
        id_warehouse: warehouse_enderecamento,
        id_endereco: endereco_enderecamento,
        id_usuario: localStorage.usuario,
        data: dateToday(),
        hora: hoursNow()
      }]
    };

    api.post("/api/setAddressing", data)
      .then((response) => {
        setChanges(response);
        setEnableSave(false);

        toast.success('Endereçamento Realizado!');
      }).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
      });

    inicializeEnderecamento();
  }

  function searchDocuments(e) {
    api.get("/api/entry_documents/searchDocuments?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListSearchDocuments(response.data.entradas);
      }).catch((error) => {
        showMessageError(error.response.data);
      });

    setNumeroDocumento(e.target.value);
  }

  function verifyConfirmStatusTitle() {
    if (confirmationOperation === '002') {
      return 'Deseja realmente reabrir a conferência?';
    }

    if (confirmationOperation === '003') {
      return 'Deseja realmente finalizar a conferência?';
    }
  }

  function selectDocument(item) {
    api.get("/api/entry_documents/selectDocument?id=" + item.id)
      .then((response) => {
        setDocumentoEntrada(response.data.row.id);
        setCidade(response.data.row.cidade);
        setEstado(response.data.row.estado);
        setInfos((prevState) => ({...prevState, data_emissao: response.data.row.data_emissao, data_entrada: response.data.row.data_entrada}));
        setHoraEntrada(response.data.row.hora_entrada);
        setWarehouseReceipt(response.data.row.warehouse_receipt);
        setLabelWarehouseReceipt(response.data.row.label_warehouse_receipt);
        setNomeCliente(response.data.row.nome_cliente);
        setNumeroDocumento(response.data.row.numero_documento);
        setSerieDocumento(response.data.row.serie_documento);
        setItens(response.data.itens);
        setConferencia(response.data.conferencia);
        setListSearchAllConference(makeSearch(response.data.conferencia, ['data_ate_conferencia', 'data_conferencia', 'etiqueta_produto_conferencia', 'etiqueta_palete_conferencia', 'hora_conferencia', 'lote_conferencia', 'numero_mac_conferencia', 'numero_serie_conferencia', 'produto_conferencia', 'qtde_conferida_conferencia', 'referencia_caixa_conferencia', 'nome_usuario_conferencia', 'sequencial_conferencia', 'status_conferencia'], termSearchConference));
        setEnderecamento(response.data.enderecamento);
        setListSearchAllAdressing(makeSearch(response.data.enderecamento, ['data_enderecamento', 'etiqueta_palete_enderecamento', 'hora_enderecamento', 'usuario_enderecamento'], termSearchAdressing));

        let aux_qtde = 0;
        let aux_qtde_conferida = 0;

        response.data.itens.map((element) => {
          if (!element.qtde_conferida_item) {
            element.qtde_conferida_item = 0;
          }
          if (!element.quantidade_item) {
            element.quantidade_item = 0;
          }
          aux_qtde += parseFloat(element.quantidade_item);
          aux_qtde_conferida += parseFloat(element.qtde_conferida_item);
        });

        setTotalQtde(aux_qtde.toFixed(2));
        setTotalQtdeConferida(aux_qtde_conferida.toFixed(2));
      }).catch((error) => {
        showMessageError(error.response.data);
      });

    setListSearchDocuments([]);
  }

  function confirmReleasedConference(response) {
    setModalReleaseConference(false);
    setEnableSave(true);

    if (response === true) {
      api.put(`/api/receipt_documents/releaseConference?id=${id}`)
        .then((response) => {
          setEnableSave(false);
          setModalReleaseConference(false);
          setStatus('007')
          toast.success('Status alterado com sucesso!');
        }).catch((error) => {
          setEnableSave(false);
          setModalReleaseConference(true);
          showMessageError(error.response.data);
        });

    }
  }

  function releaseConference() {
    setModalReleaseConference(true);
  }

  function getOptionTag() {
    if (parameterTagCompanie == 'T') {
      return 'S';
    } else if (parameterTagClient == 'S') {
      return 'S';
    } else {
      return 'N';
    }
  }

  function makeConference() {
    if (blockWarehouseReceipt == 'F' || (warehouse_receipt && blockWarehouseReceipt != '')) {
      setRequestPallet(getOptionTag());
      inicializeItemConference();
      setShowModals((prevState) => ({ conferenceOpenWithoutTag: true }));
    } else {
      setShowModals((prevState) => ({ modalEditWarehouseReceipt: true }));
      setEditWarehouseReceipt(warehouse_receipt);
    }
  }

  function closeModalConfirmPrintTags() {
    setShowModals((prevState) => ({ ...prevState, modalConfirmPrintTags: false}))
  }
  
  function closeModal() {
    setShowModals((prevState) => ({ ...prevState, modalConfirmClearConference: false, modalTagsReceipt: false, conferenceOpen: false, conferenceOpenWithoutTag: false, enderecamentoOpen: false, confirmExit: false, featuresOpen: false, addressingOpen: false }))
    setModalConfirmStatus(false);
    setEnableSave(false);
    inicializeItemConference();
    setViewItens([]);
  }

  function finishConference() {
    setConfirmationOperation('003');
    setModalConfirmStatus(true);
  }

  function reopenConference() {
    setConfirmationOperation('002');
    setModalConfirmStatus(true);
  }

  function aproveConference() {
    setConfirmationOperation('004');
    setShowModals((prevState) => ({ ...prevState, confirmAddressing: true }));
  }

  function confirmStatus(value) {
    setEnableSave(true);
    setModalConfirmStatus(false);

    if (value) {
      api.get(`/api/receipt_documents/changeStatus?id=${id}&status=${confirmationOperation}${enderecador.value ? `&associado_para=${enderecador.value}` : ""}`)
        .then((response) => {
          setChanges(response);
          setShowModals((prevState) => ({ ...prevState, confirmAddressing: false }));

          inicializeItemConference();
          toast.success('Status alterado com sucesso!');
        }).catch((error) => {
          setEnableSave(false);
          console.log(error.response.data)
          showMessageError(error.response.data);
        });
    } else {
      setConfirmationOperation('');
      setEnableSave(false);
    }
  }
  
  function setCodPalete(e) {
    setConferencePalete(e.target.value.toUpperCase());

    if (e.target.value.length === 17) {
      api.get("/api/receipt_documents/getCheckTag?type=P&tag=" + e.target.value.toUpperCase() + "&receipt=" + id + "&product=" + conferenceIdProduct)
        .then((response) => {

        }).catch((error) => {
          showMessageError(error.response.data);
        });
    }
  }

  function selectWarehouse(value) {
    if (value && value != '') {
      api.get("/api/getAdressesAvailable?warehouse=" + value)
        .then((response) => {
          setListEnderecos(response.data.enderecos);
        }).catch((error) => {
          showMessageError(error.response.data);
        });
    } else {
      setListEnderecos([]);
    }
  }

  function inicializeItemConference() {
    setConferenceIdProduct('');
    setConferenceProduct('');
    setConferencePalete('');
    setConferenceQtde('');
    setConferenceRefCaixa('');
    setLoteConferencia('');
    setSerieConferencia('');
    setMacConferencia('');
    setAllowChangeLoteConferencia('');
    setControlsBatchConferencia('');
    setControlsSerieConferencia('');
    setControlsMacConferencia('');
    setConferenceFeatures([]);
  }

  function validItemWithoutTag() {
    if ((controls_serie_conferencia === 'S' && (!serie_conferencia || serie_conferencia === '')) || 
        (controls_mac_conferencia === 'S' && (!mac_conferencia || mac_conferencia === '')) || 
        (request_pallet === 'S' && (!conferencePalete || conferencePalete === '')) || 
        (controls_batch_conferencia === 'S' && (!lote_conferencia || lote_conferencia === '')) || 
        ((!conferenceIdProduct || conferenceIdProduct === '')) || 
        ((!conferenceQtde || conferenceQtde === ''))) {
      return false;
    } else {
      return true;
    }

  }

  function validItem() {
    if ((conferenceIdProduct !== '') && (conferenceQtde !== '')) {
      return true;
    } else {
      return false;
    }

  }

  function confirmReleasedRefBox(response) {
    setReleasedRefBox(response);
    setModalReleasedRef(false);

    if (response === true) {
      setReleasedRefBox(response);
      setModalReleasedRef(false);
      confirmItem(false, response);
    }
  }

  function openRemoveConference(index, item) {
    setModalRemoveConference(true);
    setIndexRemoveConference(index);
    setItemRemoveConference(item);
  }

  function confirmRemoveConference(response) {
    setModalRemoveConference(false);

    if (response === true) {
      setModalRemoveConference(false);
      removeConferencia(indexRemoveConference, itemRemoveConference);
    }
  }

  function confirmItemWithoutTag() {
    if (validItemWithoutTag() === true) {
      setEnableSave(true);

      const data = {
        list: [{
          id_recebimento: id,
          id_produto: conferenceIdProduct,
          etiqueta_palete: conferencePalete,
          qtde_conferida: conferenceQtde,
          lote: lote_conferencia,
          serie: serie_conferencia,
          mac: mac_conferencia,
          referencia_caixa: conferenceRefCaixa,
          conference_features: conferenceFeatures,
          id_usuario: localStorage.usuario
        }]
      };

      api.post("/api/receipt_documents/setConference", data)
        .then((response) => {
          setChanges(response);
          toast.success('Conferência Realizada.');
        }).catch((error) => {
          showMessageError(error.response.data);
          setEnableSave(false);
        });
    } else {
      toast.error('Preencha os campos com * para confirmar o item.');
    }
  }

  function setChanges(response) {
    setStatus(response.data.row.status);
    setLabelStatus(response.data.row.label_status);
    setWarehouseReceipt(response.data.row.warehouse_receipt);
    setLabelWarehouseReceipt(response.data.row.label_warehouse_receipt);
    setItens(response.data.itens);
    setConferencia(response.data.conferencia);
    setListSearchAllConference(makeSearch(response.data.conferencia, ['data_ate_conferencia', 'data_conferencia', 'etiqueta_produto_conferencia', 'etiqueta_palete_conferencia', 'hora_conferencia', 'lote_conferencia', 'numero_mac_conferencia', 'numero_serie_conferencia', 'produto_conferencia', 'qtde_conferida_conferencia', 'referencia_caixa_conferencia', 'nome_usuario_conferencia', 'sequencial_conferencia', 'status_conferencia'], termSearchConference));
    setEnderecamento(response.data.enderecamento);
    setListSearchAllAdressing(makeSearch(response.data.enderecamento, ['data_enderecamento', 'etiqueta_palete_enderecamento', 'hora_enderecamento', 'usuario_enderecamento'], termSearchAdressing));
    setEnableSave(false);
    inicializeItemConference();

    let aux_qtde = 0;
    let aux_qtde_conferida = 0;

    response.data.itens.map((element) => {
      if (!element.qtde_conferida_item) {
        element.qtde_conferida_item = 0;
      }
      if (!element.quantidade_item) {
        element.quantidade_item = 0;
      }
      aux_qtde += parseFloat(element.quantidade_item);
      aux_qtde_conferida += parseFloat(element.qtde_conferida_item);
    });

    setTotalQtde(aux_qtde.toFixed(2));
    setTotalQtdeConferida(aux_qtde_conferida.toFixed(2));
  }

  function confirmItem(closePalete, aux_releasedRefBox = releasedRefBox) {
    if (validItem() === true) {
      let aux_ref_repetido = true;
      conferencia.map((element) => {
        if (element.referencia_caixa_conferencia !== '' && (element.referencia_caixa_conferencia === conferenceRefCaixa)) {
          aux_ref_repetido = false;
        }
      });

      if (aux_ref_repetido || aux_releasedRefBox) {
        setReleasedRefBox(false);

        let data = {
          list: [
            {
              id_recebimento: id,
              etiqueta_palete: searchPalete,
              id_produto: conferenceIdProduct,
              qtde_conferida: conferenceQtde,
              referencia_caixa: conferenceRefCaixa,
              conference_features: conferenceFeatures,
            }
          ]
        };

        api.post("/api/receipt_documents/setConference", data)
          .then((response) => {
            setChanges(response);

            if (closePalete === true) {
              setSearchPalete('');
            }
          }).catch((error) => {
            showMessageError(error.response.data);
          });
      } else {
        setModalReleasedRef(true);
      }
    } else {
      toast.error('Preencha os campos com * para confirmar o item.');
    }
  }

  function confirmSelectWarehouse() {
    if (edit_warehouse_receipt && edit_warehouse_receipt != '') {
      let data = {
        id_recebimento: id,
        warehouse_receipt: edit_warehouse_receipt
      };

      api.put("/api/receipt_documents/setWarehouseReceipt", data)
        .then((response) => {
          setChanges(response);
          setShowModals((prevState) => ({ ...prevState, modalEditWarehouseReceipt: false }));
          toast.success('Armazém selecionado.');
        }).catch((error) => {
          showMessageError(error.response.data);
        });
    } else {
      toast.error('Selecione um armazém.');
    }
  }

  function searchProductConference(e) {
    api.get("/api/getSearchProductBarcodes?term=" + e.target.value.toLowerCase() + `${id ? `&recebimento=${id}` : ""}`)
      .then((response) => {
        if (response.data.exact_item) {
          selectProductItem(response.data.products_list[0]);
        } else {
          setListPoductsConference(response.data.products_list);
        }
      }).catch((error) => {
        showMessageError(error.response.data);
      });

    setConferenceProduct(e.target.value);
  }

  function selectProductItem(item) {
    setConferenceIdProduct(item.id);
    setConferenceProduct(item.descricao);
    setConferenceQtde(item.qtde_conferencia);
    setListPoductsConference([]);
    setConferenceFeatures([]);

    api.get("/api/getFeaturesByProductDocument?id=" + item.id + `&doc=${id}`)
      .then((response) => {
        setDisabledFeature(false);
        setConferenceFeatures(response.data.features);

        response.data.features.map((element) => {
          if (element.valor && element.valor != '') {
            setDisabledFeature(true);
          }
        })

        setControlsSerieConferencia(response.data.serie);
        setControlsMacConferencia(response.data.mac);
        setControlsBatchConferencia(response.data.batch.controls_batch);
        
        if (response.data.serie == 'S') {
          setConferenceQtde(1);
        }
        
        if (response.data.batch.controls_batch == 'S') {
          setAllowChangeLoteConferencia(response.data.batch.allow_change);
          setAllowNewLoteConferencia(response.data.batch.allow_new);
          setBatchsConferencia(response.data.batch.batchs);
          
          if (response.data.batch.allow_new == 'S') {
            setLoteConferencia(response.data.batch.batchs[response.data.batch.batchs.length-1].batch);
          }
          
          if (response.data.batch.allow_change == 'N') {
            setLoteConferencia(response.data.batch.batchs[0].batch);
          }
        }
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function getDataFeatures(item) {
    api.get("/api/receipt_documents/getDataFeatures?id=" + item.ident_item)
      .then((response) => {
        setFeature(response.data.caracteristicas);
        setShowModals((prevState) => ({ ...prevState, featuresOpen: true }))
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function receiptTableHeader(title) {
    return (
      <div className="receipt__header">
        <h2 className="receipt___title">{title}</h2>
        <div className="receipt___input">
          <input type="text" onChange={searchAdressing} placeholder="Pesquisar" />
          <FaSearch className="receipt____icon" size={16} />
        </div>
      </div>
    )
  }

  function checkWhichRowReceiptTableAndWasClicked(id) {
    setRowReceiptTableWasClicked(rowReceiptTableWasClicked.map((row) => {
      if (row.id !== id && row.clicked) {
        row.clicked = false;
      }

      if (row.id === id) {
        row.clicked = true;
      }

      return row;
    }));
  }

  function checkIfAddressingIsRequiredAndConfirmStatus() {
    if (receivingAddressing === 2 && !enderecador.value) {
      return toast.error("De acordo com o parâmetro atual, o campo de endereçador é obrigatório.");
    }

    return confirmStatus(true);
  }

  function getListTags() {
    setListTagsReceiptByProduct([]);
    setGenerationTags(() => ({ label_product: '', id_product: '', quantity: 0 }));
    api.get("/api/tags/getSummaryTagsByOrigin?id=" + id + "&origin=001")
      .then((response) => {
        setListTagsReceipt(response.data.list_tags);
        setShowModals((prevState) => ({ ...prevState, modalTagsReceipt: true }));
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function setClearListTagsByProduct() {
    setGenerationTags(() => ({ label_product: '', id_product: '', quantity: 0 }));
    setListTagsReceiptByProduct([]);
  }

  function getListTagsByProduct(item) {
    setGenerationTags(() => ({ label_product: item.product, id_product: item.id_product, quantity: 0 }));

    api.get("/api/receipt_documents/getTagsByReceiptItem?id=" + id + "&id_product=" + item.id_product)
      .then((response) => {
        setListTagsReceiptByProduct(response.data.list_tags);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function getPrintTag() {
    closeModalConfirmPrintTags();
    axios.post(
      baseUrl + "api/tags/printList", listTagsToPrint,
      {
        responseType: 'blob',
        headers: {
          empresa: localStorage.empresa,
          usuario: localStorage.usuario
        }
      }

    ).then((response) => {
      const content = response.headers['content-type'];
      download(response.data, 'etiquetas.pdf', content);
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function generateTags() {
    api.post("/api/receipt_documents/setGenerateTags", listTagsReceipt)
    .then((response) => {
      setListTagsReceipt(response.data.list);
      if (response.data.list_tags.length == 0) {
        toast.error('Nenhuma etiqueta gerada, selecione a quantidade!');
      } else {
        setListTagsToPrint(response.data.list_tags);
        setShowModals((prevState) => ({ ...prevState, modalConfirmPrintTags: true }));
      }
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  useEffect(() => {
    getUsers(setUsers, setCarrying);
  }, []);

  useEffect(() => {
    if (userSearch) {
      getUsers(setUsers, setCarrying);
    }
  }, [userSearch])

  return (
    <div>
      <Header />
      <Division />
      <Lateral />
      <ReactTooltip />

      <ModalAuxiliaresData 
        showModalAuxiliariesData={{state: showModalAuxiliariesData, setState: setShowModalAuxiliariesData}} 
        headerAuxiliaresDatas={{state: headerAuxiliaresDatas, setState: setHeaderAuxiliaresDatas}} 
        currentItem={{state: currentItem, setState: setCurrentItem}}
        itens={{state: itens, setState: setItens}}
        origin={origin} 
        view={view} 
        typeItens="controle-recebimentos"
      />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Controle de Recebimento">
          <Link onClick={() => window.history.back()}>
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Status</label><br />
                  <input type="text" placeholder="Status" value={label_status} disabled={true} />
                </div>
                <div className="formDiv">
                  <label>Número do Documento</label><br />
                  <input type="text" placeholder="Número do Documento" value={numero_documento} onChange={searchDocuments} maxLength="9" disabled={serie_documento || origin !== '' && origin !== '002'} />
                  <ul className="dropdown-menu" id="transportDatalist">
                    {listSearchDocuments.map((item, index) => (
                      <li key={index} onClick={() => selectDocument(item)}>
                        <a>{item.serie_documento} - {item.numero_documento}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="formDiv">
                  <label>Série do Documento</label><br />
                  <input type="text" placeholder="Série do Documento" value={serie_documento} onChange={(e) => setSerieDocumento(e.target.value)} maxLength="3" disabled={true} />
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Cliente/Fornecedor</label><br />
                  <input type="text" placeholder="Cliente/Fornecedor" value={nome_cliente} onChange={(e) => setNomeCliente(e.target.value)} maxLength="60" disabled={true} />
                </div>
                <div className="formDiv">
                  <label>Cidade</label><br />
                  <input type="text" placeholder="Cidade" value={cidade} onChange={(e) => setCidade(e.target.value)} maxLength="60" disabled={true} />
                </div>
                <div className="formDiv">
                  <label>Estado</label><br />
                  <input type="text" placeholder="Estado" value={estado} onChange={(e) => setEstado(e.target.value)} maxLength="60" disabled={true} />
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Data de Emissão</label><br />
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_emissao" disabled />
                </div>
                <div className="formDiv">
                  <label>Data de Entrada</label><br />
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_entrada" disabled />
                </div>
                <div className="formDiv">
                  <label>Hora de Entrada</label><br />
                  <input type="text" placeholder="##/##/####" value={hora_entrada} onChange={(e) => setHoraEntrada(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true} />
                </div>
              </div>
              <div className="divGroup">
                {blockWarehouseReceipt == 'T' && <div className="formDiv">
                  <label>Armazém de Recebimento</label><br />
                  <input type="text" placeholder="Armazém de Recebimento" value={label_warehouse_receipt} disabled={true} />
                </div>}
                <div className="formDiv">
                  <label>Observação</label><br />
                  <input type="text" placeholder="Observação" value={observation} onChange={(e) => setObservation(e.target.value)} maxLength="250" disabled={view || origin !== '' && origin !== '002'} />
                </div>
                {id && <div className="formDiv">
                  <label>Transbordo</label><br/>
                  <select value={transshipment} onChange={(e) => setTransshipment(convertStringValueToBoolean(e.target.value))} disabled={view || origin !== '' && origin !== '002'}>                    
                    <option value={true}>Sim</option>
                    <option value={false}>Não</option>
                  </select>
                </div>}
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th className="receipt-table-header" style={{ backgroundColor: `${rowReceiptTableWasClicked[0].clicked ? "#f3f3f3" : ""}` }} onClick={() => { setCurrentReceiptTable(1); checkWhichRowReceiptTableAndWasClicked(1) }}>Itens</th>
                  <th className="receipt-table-header" style={{ backgroundColor: `${rowReceiptTableWasClicked[1].clicked ? "#f3f3f3" : ""}` }} onClick={() => { setCurrentReceiptTable(2); checkWhichRowReceiptTableAndWasClicked(2) }}>Conferência</th>
                  <th className="receipt-table-header" style={{ backgroundColor: `${rowReceiptTableWasClicked[2].clicked ? "#f3f3f3" : ""}` }} onClick={() => { setCurrentReceiptTable(3); checkWhichRowReceiptTableAndWasClicked(3) }}>Endereçamento</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {currentReceiptTable === 1 &&
                    <td className='receipt' colSpan={3}>
                      {receiptTableHeader("Itens")}
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="ident-th">Diver.</th>
                            <th className="ident-th">#</th>
                            <th scope="col">Status</th>
                            <th className="double-th" scope="col">Produto</th>
                            <th scope="col">Tipo</th>
                            <th scope="col">Unidade Medida</th>
                            {listAllFeatures.length > 0 && <th scope="col">Característica</th>}
                            <th scope="col">Quantidade</th>
                            <th scope="col">Quantidade Conferida</th>
                            <th scope="col">Dif. Quantidade</th>
                            {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - CONFERIR') && conferenceStatus.indexOf(status) > -1 && <th className="ident-th">Limpa Conf.</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {itens.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{showIconDivergence(item.qtde_conferida_item, item.quantidade_item)}</td>
                                <td>
                                  {index + 1}
                                </td>
                                <td data-label="">{viewItem(listStatusItem, item.status_item)}</td>
                                <td data-label="">{item.produto_item}</td>
                                <td data-label="">{viewItem(listTiposProdutos, item.tipo_produto_item)}</td>
                                <td data-label="">{item.um_enderecamento}</td>
                                {listAllFeatures.length > 0 && <td data-label="">
                                  <div className="formDivRow">
                                    <button type="button" className="buttonTable" onClick={() => getDataFeatures(item)}>Características</button>
                                  </div>
                                </td>}
                                <td data-label="">{item.quantidade_item ? item.quantidade_item : 0}</td>
                                <td data-label="">{item.qtde_conferida_item ? item.qtde_conferida_item : 0}</td>
                                <td data-label="">{(item?.quantidade_item && item?.qtde_conferida_item) ? parseInt(item?.quantidade_item) - parseInt(item?.qtde_conferida_item) : 0}</td>
                                {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - CONFERIR') && conferenceStatus.indexOf(status) > -1 && <td>
                                  <Link className="action" onClick={() => {setItemToRemove(item); setShowModals((prevState) => ({ ...prevState, modalConfirmClearConference: true }))}}>
                                    <FaTrash color="#000" size={17} />
                                  </Link>
                                </td>}
                              </tr>
                            )
                          })}
                          <tr>
                            <td>{showIconDivergence(totalQtdeConferida, totalQtde)}</td>
                            <td colSpan={listAllFeatures.length > 0 ? 5 : 4}></td>
                            <td data-label="">Total: </td>
                            <td data-label="">{totalQtde}</td>
                            <td data-label="">{totalQtdeConferida}</td>
                            <td data-label=""></td>
                            <td data-label=""></td>
                          </tr>
                          {itens?.length === 0 &&
                            <tr>
                              <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </td>
                  }
                  {currentReceiptTable === 2 &&
                    <td className='receipt' colSpan={3}>
                      {receiptTableHeader("Conferência")}
                      <table className={dataTable}>
                        <thead>
                          <tr>
                            <th className="ident-th">#</th>
                            <th scope="col">Produto</th>
                            <th scope="col">Etiqueta Palete</th>
                            {listAllFeatures.length > 0 && <th scope="col">Características</th>}
                            <th scope="col">Tipo</th>
                            <th scope="col">Unidade Medida</th>
                            <th scope="col">Quantidade Conferida</th>
                            <th scope="col">Lote</th>
                            <th scope="col">Número Série</th>
                            <th scope="col">Número MAC</th>
                            <th scope="col">Observação</th>
                            <th scope="col">Data</th>
                            <th scope="col">Hora</th>
                            <th scope="col">Usuário</th>
                            <th scope="col">Opções</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listSearchAllConference.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {index + 1}
                                </td>
                                <td data-label="Produto">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Produto" value={produto_conferencia} onChange={(e) => setProdutoConferencia(e.target.value)} maxLength="60" disabled={true} />
                                  </div>}
                                  {ident_conferencia !== index && item.produto_conferencia}
                                </td>
                                <td data-label="Etiqueta Palete">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Etiqueta Palete" value={etiqueta_palete_conferencia} onChange={(e) => setEtiquetaPaleteConferencia(e.target.value)} maxLength="14" disabled={true} />
                                  </div>}
                                  {ident_conferencia !== index && item.etiqueta_palete_conferencia}
                                </td>
                                {listAllFeatures.length > 0 && <td data-label="Caracteristicas">
                                  <div className="formDivRow">
                                    <button type="button" className="buttonTable" onClick={() => getDataFeatures(item)}>Ver características</button>
                                  </div>
                                </td>}
                                <td data-label="Tipo Produto">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <select value={tipo_produto_conferencia} onChange={(e) => setTipoProdutoConferencia(e.target.value)} disabled={true}>
                                      <option value="">Selecione</option>
                                      {listTiposProdutos.map((item, index) => (
                                        <option key={index} value={item.id}>{item.descricao}</option>
                                      ))}
                                    </select>
                                  </div>}
                                  {ident_conferencia !== index && viewItem(listTiposProdutos, item.tipo_produto_conferencia)}
                                </td>
                                <td data-label="Unidade de Medida">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <select value={um_conferencia} onChange={(e) => setUmConferencia(e.target.value)} disabled={true}>
                                      <option value="">Selecione</option>
                                      {listUnidades.map((item, index) => (
                                        <option key={index} value={item.id}>{item.descricao}</option>
                                      ))}
                                    </select>
                                  </div>}
                                  {ident_conferencia !== index && viewItem(listUnidades, item.um_conferencia)}
                                </td>
                                <td data-label="Qtde Conferida">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Quantidade Conferida" value={qtde_conferida_conferencia} onChange={(e) => setQtdeConferidaConferencia(setMaskDecimal(e.target.value, 4))} maxLength="20" disabled={view} />
                                  </div>}
                                  {ident_conferencia !== index && item.qtde_conferida_conferencia}
                                </td>
                                <td data-label="Lote">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Lote" value={lote_conferencia} onChange={(e) => setLoteConferencia(e.target.value)} maxLength="20" disabled={view} />
                                  </div>}
                                  {ident_conferencia !== index && item.lote_conferencia}
                                </td>
                                <td data-label="Número Série">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Número Série" value={numero_serie_conferencia} onChange={(e) => setNumeroSerieConferencia(e.target.value)} maxLength="30" disabled={view} />
                                  </div>}
                                  {ident_conferencia !== index && item.numero_serie_conferencia}
                                </td>
                                <td data-label="Número MAC">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Número MAC" value={numero_mac_conferencia} onChange={(e) => setNumeroMacConferencia(e.target.value)} maxLength="12" disabled={view} />
                                  </div>}
                                  {ident_conferencia !== index && item.numero_mac_conferencia}
                                </td>
                                <td data-label="Observação">
                                  {ident_conferencia === index && <div className="formDivRow">
                                    <input type="text" placeholder="Observação" value={referencia_caixa_conferencia} onChange={(e) => setReferenciaCaixaConferencia(e.target.value)} maxLength="12" disabled={view} />
                                  </div>}
                                  {ident_conferencia !== index && item.referencia_caixa_conferencia}
                                </td>
                                <td data-label="Data">
                                  {ident_conferencia === index && <div className="formDiv">
                                    <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_conferencia" disabled />
                                  </div>}
                                  {ident_conferencia !== index && item.data_conferencia}
                                </td>
                                <td data-label="Hora">
                                  {ident_conferencia === index && <div className="formDiv">
                                    <input type="text" placeholder="##:##:##" value={hora_conferencia} onChange={(e) => setHoraConferencia(setMaskHour(e.target.value, "##:##:##"))} maxLength="8" disabled={true} />
                                  </div>}
                                  {ident_conferencia !== index && item.hora_conferencia}
                                </td>
                                <td data-label="Usuário">
                                  {ident_conferencia === index && <div className="formDiv">
                                    <input type="text" placeholder="Usuário" value={nome_usuario_conferencia} onChange={(e) => setNomeUsuarioConferencia(e.target.value)} maxLength="50" disabled={true} />
                                  </div>}
                                  {ident_conferencia !== index && item.nome_usuario_conferencia}
                                </td>
                                <td data-label="Opções">
                                  {ident_conferencia === index && 
                                  <div className="addressing-buttons">
                                    <button type="button" className="buttonModalList" onClick={salvarConferencia} disabled={view}><FaCheck /></button>
                                    <button type="button" className="buttonModalList" onClick={inicializeConferencia} disabled={view}><ImCross /></button>
                                  </div>}
                                  {ident_conferencia !== index && (statusFlow == 'F' || ['002'].indexOf(status) > -1) && <div>
                                    {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - EDITAR CONFERENCIA') && <Link className="action" onClick={() => editConferencia(index, item)}>
                                      <FaPen color="#000" size={17} />
                                    </Link>}
                                    {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - REMOVER CONFERENCIA') && <Link className="action" onClick={() => openRemoveConference(index, item)}>
                                      <FaTrash color="#000" size={17} />
                                    </Link>}
                                  </div>}
                                </td>
                              </tr>
                            )
                          })}
                          {listSearchAllConference.length === 0 &&
                            <tr>
                              <td colSpan={listAllFeatures.length > 0 ? 15 : 14}><label className='required'>Nenhum registro encontrado!</label></td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </td>
                  }
                  {currentReceiptTable === 3 &&
                    <td className='receipt' colSpan={3}>
                      {receiptTableHeader("Endereçamento")}
                      <table className="receipt__table">
                        <thead>
                          <tr>
                            <th className="ident-th">#</th>
                            <th className="min-th" scope="col">Etiqueta Palete</th>
                            <th className="min-th" scope="col">Produto</th>
                            <th className="min-th" scope="col">Qtde</th>
                            <th className="min-th" scope="col">Armazém</th>
                            <th className="min-th" scope="col">Endereço</th>
                            <th className="min-th" scope="col">Data</th>
                            <th className="min-th" scope="col">Hora</th>
                            <th className="min-th" scope="col">Usuário Endereçou</th>
                            <th scope="col">Opções</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listSearchAllAdressing.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {item.status_enderecamento === '001' ? <FiSettings data-tip="Em conferência" color="#F6a935" size={17} /> : ''}
                                  <ReactTooltip />
                                  {item.status_enderecamento === '002' ? <FaClipboard data-tip="Pendente Endereçamento" color="#F00" size={17} /> : ''}
                                  <ReactTooltip />
                                  {item.status_enderecamento === '003' ? <FaCheck data-tip="Finalizado" color="#001675" size={17} /> : ''}
                                  <ReactTooltip />
                                </td>
                                <td data-label="Etiqueta Palete">
                                  {ident_enderecamento === index && <div className="formDivRow">
                                    <input type="text" placeholder="Etiqueta Palete" value={etiqueta_palete_enderecamento} onChange={(e) => setEtiquetaPaleteEnderecamento(e.target.value)} maxLength="14" disabled={true} />
                                  </div>}
                                  {ident_enderecamento !== index && item.etiqueta_palete_enderecamento}
                                </td>
                                <td data-label="Produto">
                                  {item.produto_enderecamento}
                                </td>
                                <td data-label="Produto">
                                  {item.qtde_conferida_enderecamento}
                                </td>
                                <td data-label="Endereço">
                                  {ident_enderecamento === index && <div className="formDivRow">
                                    <select data-tip data-for="registerTip" value={warehouse_enderecamento} onChange={(e) => { selectWarehouse(e.target.value); setWarehouseEnderecamento(e.target.value) }} disabled={disabled_enderecamento || warehouse_receipt || warehouse_mandatory}>
                                      <option value="">Selecione</option>
                                      {listWarehouse.map((item, index) => (
                                        <option key={index} value={item.id}>{item.descricao}</option>
                                      ))}
                                    </select>
                                  </div>}
                                  {ident_enderecamento !== index && item.label_warehouse_enderecamento}
                                </td>
                                <td data-label="Endereço">
                                  {ident_enderecamento === index && <div className="formDivRow">
                                    <select data-tip data-for="registerTip" value={endereco_enderecamento} onChange={(e) => setEnderecoEnderecamento(e.target.value)} disabled={disabled_enderecamento}>
                                      <option value="">Selecione</option>
                                      {listEnderecos.map((item, index) => (
                                        <option key={index} value={item.id}>{item.descricao}</option>
                                      ))}
                                    </select>
                                  </div>}
                                  {ident_enderecamento !== index && item.label_address_enderecamento}
                                </td>
                                <td data-label="Data">
                                  {ident_enderecamento === index && <div className="formDiv">
                                    <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_enderecamento" disabled />
                                  </div>}
                                  {ident_enderecamento !== index && item.data_enderecamento}
                                </td>
                                <td data-label="Hora">
                                  {ident_enderecamento === index && <div className="formDiv">
                                    <input type="text" placeholder="##:##:##" value={hora_enderecamento} onChange={(e) => setHoraEnderecamento(setMaskHour(e.target.value, "##.##.##"))} maxLength="8" disabled={true} />
                                  </div>}
                                  {ident_enderecamento !== index && item.hora_enderecamento}
                                </td>
                                <td data-label="Usuário">
                                  {ident_enderecamento === index && <div className="formDiv">
                                    <input type="text" placeholder="Usuário" value={usuario_enderecamento} onChange={(e) => setUsuarioEnderecamento(e.target.value)} maxLength="60" disabled={true} />
                                  </div>}
                                  {ident_enderecamento !== index && <div className="formDiv">
                                    <p>{item.usuario_enderecamento}</p>
                                  </div>}
                                </td>
                                <td data-label="Opções">
                                  {ident_enderecamento === index
                                    ?
                                    <div className="addressing-buttons">
                                      <button type="button" className="buttonModalList" onClick={salvarEnderecamento} disabled={view}><FaCheck /></button>
                                      <button type="button" onClick={inicializeEnderecamento} className="buttonModalList"><ImCross /></button>
                                    </div>
                                    :
                                    <>
                                      {getPermission("OPERACOES - CONTROLE RECEBIMENTOS - ENDERECAR") && (status === '004' || status === '005') && item.status_enderecamento == '002' &&
                                        <>
                                          {origin !== "003" &&
                                            <Link className="action" onClick={() => editEnderecamento(index, item)}>
                                              <FaPen color="#000" size={17} />
                                            </Link>
                                          }
                                          {origin === "003" &&
                                            <Link className="action" onClick={() => showAddressItem(index, item)}>
                                              <FaPen color="#000" size={17} />
                                            </Link>
                                          }
                                        </>
                                      }
                                      <Link className="action" onClick={() => viewAddressing(item)}>
                                        <FaPlus color="#000" size={17} />
                                      </Link>
                                    </>
                                  }
                                </td>
                              </tr>
                            )
                          })}
                          {listSearchAllAdressing?.length === 0 &&
                            <tr>
                              <td colSpan={10}><label className='required'>Nenhum registro encontrado!</label></td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </td>
                  }
                </tr>
              </tbody>
            </table>
            {!view && <div className="formDiv" style={{display: "flex", gap: "0.5rem"}}>
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - CADASTRO') && !id && <button type="submit" className="buttonSubmit" onClick={save} disabled={view || enableSave}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              <button type="button" className="buttonTab" onClick={() => setShowModalAuxiliariesData(true)}>Dados auxiliares</button>
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - REABRIR') && status === '003' && <button type="button" className="buttonRemove pullRight" onClick={reopenConference} disabled={view || enableSave}>Reabrir Conferência</button>}
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - APROVAR') && status === '003' && <button type="button" className="buttonRemove pullRight" onClick={aproveConference} disabled={view || enableSave}>Aprovar Conferência</button>}
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - FINALIZAR') && status === '002' && <button type="button" className="buttonRemove pullRight" onClick={finishConference} disabled={view || enableSave}>Finalizar Conferência</button>}
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - ALTERAR ENDERECADOR') && status === '004' && <button type="button" className="buttonRemove pullRight" onClick={() => setShowModals((prevState) => ({ ...prevState, changeAddresser: true }))} disabled={view || enableSave}>Alterar Endereçador</button>}
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - LIBERAR CONFERENCIA') && status == '001' && conferenceStatus.indexOf('007') > -1 && <button type="button" className="buttonTab" onClick={releaseConference}>Liberar P/ Conferência</button>}
              {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - CONFERIR') && conferenceStatus.indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={makeConference}>Realizar Conferência</button>}
              {['001', '002', '007'].indexOf(status) > -1 && <button type="button" className="buttonTab pullRight" onClick={getListTags}>Etiquetas</button>}
            </div>}
          </form>
        </div>
      </div>}

      <Modal
        isOpen={showModals.changeAddresser}
        onRequestClose={() => setShowModals((prevState) => ({ ...prevState, changeAddresser: false }))}
        className="modal-addressing"
        contentLabel="Alterar endereçador"
      >
        <div className="modal-addressing__choice">
          <label className="modal-addressing___label">Endereçador:</label>
          <Select value={enderecador} options={users} onChange={(e) => setEnderecador({ label: e.label, value: e.value })} className="modal-addressing___select" />
        </div>
        <div className="modal-addressing__buttons">
          <button className="modal-addressing___button" onClick={() => { setShowModals((prevState => ({ ...prevState, changeAddresser: false }))); changeAddresser() }}>Confirmar</button>
          <button className="modal-addressing___button" onClick={() => { setEnderecador((prevState) => ({ ...prevState, value: 0 })); setShowModals((prevState) => ({ ...prevState, changeAddresser: false })) }}>Fechar</button>
        </div>
      </Modal>

      <Modal
        isOpen={showModals.modalTagsReceipt}
        onRequestClose={closeModal}
        contentLabel="Etiquetas"
        style={customHalfModal}
        ariaHideApp={false}
        keepMounted
      >
        <div>
          <h2>Etiquetas</h2>
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th className="ident-th">#</th>
                  <th>Produto</th>
                  <th>Qtde Gerada</th>
                  <th>Qtde Usada</th>
                  <th>Qtde Gerar</th>
                  {false && <th>Opções</th>}
                </tr>
              </thead>
              <tbody>
                {listTagsReceipt.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index + 1}
                      </td>
                      <td>{item.product}</td>
                      <td>{item.generated}</td>
                      <td>{item.used}</td>
                      <td>
                        <input type="text" placeholder="Qtde" value={item.quantity_generate} onChange={(e) => setListTags(index, e.target.value)} maxLength="30" disabled={view} />
                      </td>
                      {false && <td>
                        {(!generationTags.id_product || item.id_product != generationTags.id_product) && <Link className="action" onClick={() => getListTagsByProduct(item)}>
                          <FaPlus color="#000" size={17} />
                        </Link>}
                        {(item.id_product == generationTags.id_product) && <Link className="action" onClick={() => setClearListTagsByProduct(item.id_product)}>
                          <FaMinus color="#000" size={17} />
                        </Link>}
                      </td>}
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={4}></td>
                  <td>
                    <button type="button" className="buttonSubmitModal inputSmModal inputSpread" onClick={generateTags} disabled={view}>Gerar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {generationTags.id_product && generationTags.id_product != '' && <div>
            <h3>Etiquetas para o produto: {generationTags.label_product}</h3>
            <div className="divGroup">
              <div className="formDiv">
                <input type="text" placeholder="Quantidade" value={generationTags.quantity} onChange={(e) => setGenerationTags((prevState) => ({ ...prevState, quantity: e.target.value }))} maxLength="30" disabled={view} />
              </div>
              <div className="formDiv">
                <button type="button" className="buttonSubmit inputSm" onClick={generateTags} disabled={view}>Gerar</button>
              </div>
            </div>
            <div className="divGroup">
              <div className="formDiv">
                <table>
                  <thead>
                    <tr>
                      <th className="ident-th">#</th>
                      <th>Código</th>
                      <th>Usada</th>
                      <th>Impressa</th>
                      <th>Imprimir</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listTagsReceiptByProduct.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {index + 1}
                          </td>
                          <td>{item.codigo}</td>
                          <td>{item.usada}</td>
                          <td>{item.impressa}</td>
                          <td>
                            <Link className="action" onClick={() => getPrintTag(item.id)}>
                              <FaPrint color="#000" size={17} />
                            </Link>
                          </td>
                        </tr>
                      )
                    })}
                    {listTagsReceiptByProduct.length == 0 && <tr>
                      <td colSpan={4}>
                        <label className='required'>Nenhuma etiqueta gerada!</label>
                      </td>
                    </tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showModals.addressingOpen}
        onRequestClose={closeModal}
        contentLabel="Itens Endereçamento"
        className="modal-addressing-open"
        ariaHideApp={false}
        keepMounted
      >
        <div>
          <div className="formDiv">
            {listItemsToAddress.length && <h2>{listItemsToAddress[0].product_code} - {listItemsToAddress[0].product_description}</h2>}<br />
            {listItemsToAddress.length && <h2>Quantidade total conferida - {sumConference}</h2>}<br />

          </div>
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Armazém</th>
                  <th>Qtde Devolvida</th>
                  <th>Endereço</th>
                  <th>Qtde a Endereçar</th>
                </tr>
              </thead>
              <tbody>
                {listItemsToAddress.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index + 1}
                      </td>
                      <td>{item.warehouse_description}</td>
                      <td>{item.quantity}</td>
                      <td>
                        <select data-tip data-for="registerTip" style={{ width: "100%" }} value={item.address} onChange={(e) => setAddressItem(index, e.target.value)}>
                          <option value="">Selecione</option>
                          {item.addresses.map((item, index) => (
                            <option key={index} value={item.id}>{item.descricao}</option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input type="text" placeholder="Quantidade" value={item.quantity_address} onChange={(e) => setQuantityItem(index, e.target.value)} maxLength="30" disabled={view} />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
            <button type="button" className="buttonSubmit pullRight" onClick={setAddressReturn} disabled={view}>Endereçar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showModals.conferenceOpenWithoutTag}
        onRequestClose={closeModal}
        style={customShortModal}
        contentLabel="Conferência"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="divGroup">
            <div className="formDiv">
              <label>{numero_documento} - {serie_documento}</label><br />
              <label>{nome_cliente}</label>
            </div>
          </div>
          <div>
            <div className="divGroup">
              <div className="formDiv">
                <label>Produto</label>&nbsp;<label className="required">*</label><br />
                <input type="text" placeholder="Produto" value={conferenceProduct} onChange={searchProductConference} maxLength="30" disabled={view} />
                <ul className="dropdown-menu" id="productsDatalist">
                  {listPoductsConference.map((item, index) => (
                    <li key={index} onClick={() => selectProductItem(item, 'N')}>
                      <a>{item.descricao}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {controls_serie_conferencia == 'S' && <div className="divGroup">
              <div className="formDiv">
                <label>Série</label>&nbsp;<label className="required">*</label><br />
                <input type="text" placeholder="Série" value={serie_conferencia} onChange={(e) => setSerieConferencia(e.target.value)} maxLength="30" disabled={view} />
              </div>
            </div>}
            {controls_mac_conferencia == 'S' && <div className="divGroup">
              <div className="formDiv">
                <label>MAC</label>&nbsp;<label className="required">*</label><br />
                <input type="text" placeholder="MAC" value={mac_conferencia} onChange={(e) => setMacConferencia(e.target.value)} maxLength="30" disabled={view} />
              </div>
            </div>}
            {request_pallet == 'S' && <div className="formDiv">
              <label>Etiqueta Palete</label>&nbsp;<label className="required">*</label><br />
              <input type="text" placeholder="Etiqueta Palete" value={conferencePalete} onChange={setCodPalete} maxLength="30" disabled={view} />
            </div>}
            {conferenceFeatures.length > 0 && conferenceFeatures.map((item, index) => (
              <div className="formDiv">
                <label>{item.descricao}</label><br />
                <input type="text" placeholder={item.descricao} value={conferenceFeatures[index].valor} onChange={(e) => setList(index, e.target.value)} maxLength="30" disabled={disabled_feature} ref={focusModalRef} />
              </div>
            ))}
            {controls_batch_conferencia == 'S' && <div className="divGroup">
              <div className="formDiv">
                <label>Lote</label>&nbsp;<label className="required">*</label><br />
                {allow_new_lote_conferencia == 'N' && batchs_conferencia.length > 0 && <select data-tip data-for="registerTip" value={lote_conferencia} onChange={(e) => { setLoteConferencia(e.target.value); }} disabled={allow_change_lote_conferencia == 'N'}>
                  <option value="">Selecione</option>
                  {batchs_conferencia.map((item, index) => (
                    <option key={index} value={item.batch}>{item.batch}</option>
                  ))}
                </select>}
                {(allow_new_lote_conferencia == 'S' || batchs_conferencia.length == 0) && <input type="text" placeholder="Lote" value={lote_conferencia} onChange={(e) => setLoteConferencia(e.target.value)} maxLength="30" disabled={allow_change_lote_conferencia == 'N'} ref={focusModalRef} />}
              </div>
            </div>}
            <div className="divGroup">
              <div className="formDiv">
                <label>Quantidade</label>&nbsp;<label className="required">*</label><br />
                <input type="text" placeholder="Quantidade" value={conferenceQtde} onChange={(e) => setConferenceQtde(setMaskDecimal(e.target.value, 4))} maxLength="30" disabled={view || controls_serie_conferencia == 'S' || controls_mac_conferencia == 'S'} ref={focusModalRef} />
              </div>
            </div>
            <div className="divGroup">
              <div className="formDiv">
                <label>Observação</label><br />
                <input type="text" placeholder="Observação" value={conferenceRefCaixa} onChange={(e) => setConferenceRefCaixa(e.target.value)} maxLength="30" disabled={view} />
              </div>
            </div>
            <div className="divGroup">
              <div className="formDiv">
                <button type="button" className="buttonSubmit inputSm marginRight" onClick={() => confirmItemWithoutTag(false)} disabled={view || enableSave}>Confirmar</button>
                <button type="button" className="buttonCancel inputSm pullRight" onClick={() => setShowModals((prevState) => ({ ...prevState, conferenceOpenWithoutTag: false }))} disabled={view}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showModals.enderecamentoOpen}
        onRequestClose={closeModal}
        style={customFullModal}
        contentLabel="Itens Endereçamento"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            {parameterTagCompanie != 'F' && <h3>Palete: {itemViewModalAddressing.etiqueta_palete_enderecamento}</h3>}
            <h3>{numero_documento} - {serie_documento}</h3><br />
            <h3>{nome_cliente}</h3><br />
            <h3>Itens Conferidos: {viewItens.length}</h3><br />
            <div>
            <input type="text" placeholder="Pesquisar" value={search_addessing} onChange={(e) => {showItem(itemViewModalAddressing, e.target.value); setSearchAddessing(e.target.value)}} />
            </div>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Produto</th>
                  <th>Unidade de Medida</th>
                  <th>Lote</th>
                  <th>Série</th>
                  <th>MAC</th>
                  <th>Observação</th>
                </tr>
              </thead>
              <tbody>
                {viewItens.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index + 1}
                      </td>
                      <td data-label="Produto">{item.produto_enderecamento}</td>
                      <td data-label="Unidade de Medida">{viewItem(listUnidades, item.um_enderecamento)}</td>
                      <td data-label="Lote">{item.lote}</td>
                      <td data-label="Serie">{item.numero_serie}</td>
                      <td data-label="MAC">{item.numero_mac}</td>
                      <td data-label="Observacao">{item.referencia_caixa_enderecamento}</td>
                    </tr>
                  )
                })}
                {viewItens?.length === 0 &&
                  <tr>
                    <td colSpan={4}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={showModals.featuresOpen}
        onRequestClose={closeModal}
        style={customShortModal}
        contentLabel="Características"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Característica</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {feature && feature.caracteristicas && feature.caracteristicas.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {index + 1}
                      </td>
                      <td data-label="Característica">{viewItem(listAllFeatures, item.id_caracteristica)}</td>
                      <td data-label="Valor">{item.valor}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showModals.confirmAddressing}
        onRequestClose={() => setShowModals((prevState) => ({ ...prevState, confirmAddressing: false }))}
        className="modal-addressing"
        contentLabel="Confirmar endereçamento"
        ariaHideApp={false}
        keepMounted
      >
        <h2 className="modal-addressing__title">Deseja realizar a aprovação?</h2>
        {(receivingAddressing === 2 || receivingAddressing === 3) &&
          <div className="modal-addressing__choice">
            <label className="modal-addressing___label">Endereçador:</label>
            <Select options={users} onChange={(e) => setEnderecador((prevState) => ({ ...prevState, value: e.value }))} className="modal-addressing___select" />
          </div>
        }

        {(receivingAddressing === 2 || receivingAddressing === 3) &&
          <div className="modal-addressing__buttons">
            <button className="modal-addressing___button" onClick={checkIfAddressingIsRequiredAndConfirmStatus}>Confirmar</button>
            <button className="modal-addressing___button" onClick={() => setShowModals((prevState) => ({ ...prevState, confirmAddressing: false }))}>Fechar</button>
          </div>
        }

        {receivingAddressing === 1 &&
          <div className="modal-addressing__buttons">
            <button className="modal-addressing___button" onClick={() => confirmStatus(true)}>Sim</button>
            <button className="modal-addressing___button" onClick={() => setShowModals((prevState) => ({ ...prevState, confirmAddressing: false }))}>Não</button>
          </div>
        }
      </Modal>

      <Modal
        isOpen={showModals.modalEditWarehouseReceipt}
        onRequestClose={() => setShowModals((prevState) => ({ ...prevState, modalEditWarehouseReceipt: false }))}
        className="modal-addressing"
        ariaHideApp={false}
        keepMounted
      >
        <div>
          <h2>Informe o armazém que esse recebimento será enderaçado?</h2>

          <div className="formDiv">
            <select value={edit_warehouse_receipt} onChange={(e) => { setEditWarehouseReceipt(e.target.value) }}>
              <option value="">Selecione</option>
              {listWarehouse.map((item, index) => (
                <option key={index} value={item.id}>{item.descricao}</option>
              ))}
            </select>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonSubmit inputSm" onClick={confirmSelectWarehouse}>Salvar</button>
            <button type="button" className="buttonCancel inputSm pullRight" onClick={() => setShowModals((prevState) => ({ ...prevState, modalEditWarehouseReceipt: false }))}>Fechar</button>
          </div>
        </div>
      </Modal>

      <ReactTooltip />
      <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => confirmReleasedConference(false)} ifOnYesIsFunction={true} functionOnYes={() => confirmReleasedConference(true)} state={modalReleaseConference} setState={setModalReleaseConference} title={"Você está liberando a confência, deseja confirmar?"} view={view} />
      <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => confirmReleasedRefBox(false)} ifOnYesIsFunction={true} functionOnYes={() => confirmReleasedRefBox(true)} state={modalReleasedRef} setState={setModalReleasedRef} title={"Referência caixa já utilizada, deseja confirmar?"} view={view} />
      <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => confirmRemoveConference(false)} ifOnYesIsFunction={true} functionOnYes={() => confirmRemoveConference(true)} state={modalRemoveConference} setState={setModalRemoveConference} title={"Você está excluindo uma conferência, deseja confirmar?"} view={view} />
      <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => confirmStatus(false)} ifOnYesIsFunction={true} functionOnYes={() => confirmStatus(true)} state={modalConfirmStatus} setState={setModalConfirmStatus} title={verifyConfirmStatusTitle()} view={view} />
      <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => closeModalConfirmPrintTags()} ifOnYesIsFunction={true} functionOnYes={() => getPrintTag()} state={showModals.modalConfirmPrintTags} title={`Você deseja imprimir as ${listTagsToPrint.length} etiquetas geradas para esse recebimento?`} view={view} />
      <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => closeModal()} ifOnYesIsFunction={true} functionOnYes={() => setClearConference()} state={showModals.modalConfirmClearConference} title={`Você deseja excluir todas as conferências do produto ${itemToRemove.produto_item} para esse recebimento?`} view={view} />
    </div>
  )
}